module.exports = __webpack_public_path__ + "public/img/3c_content.f0a2fff5.png";